import Model from 'src/app/common/model';

export default class FeedTypeModel extends Model {
  name: string;
  description?: string;
  person_id?: string;
  farm_site_id?: string;
  source?: string;
  pond_id?: number;
  feed_item_id?: number;
  mix_item_id?: number;
  feed_business_item_id?: number;
  feed_uom_id?: number;
  feed_qty_given?: number;
  mix_business_item_id?: number;
  mix_uom_id?: number;
  mix_qty_given?: number;
  pond_culture_id: any;
  feedName: any;
  feedMix: any;
  feedUOM: string;
  mixUom: any;

  constructor() {
    super();
  }
}
